import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/core/api/axios-client";

/**
 * Hook per eliminare un materiale didattico
 * DELETE /materiale_didattico/{id}
 */
export function useDeleteMaterialeDidattico() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const response = await apiClient.delete(`/materiale_didattico/${id}`);
      return response.data;
    },
    onSuccess: () => {
      // Invalida tutte le griglie materiale didattico (scorm, video, pdf)
      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey;
          return (
            Array.isArray(key) &&
            key[0] === "page" &&
            typeof key[1] === "string" &&
            key[1].startsWith("get_page/materiale_didattico")
          );
        },
      });
    },
  });
}
